module.exports = __webpack_public_path__ + "static/img/ewm.e9c75251.jpg";